const gridTemplateRow = {
    name: "grid-template-rows",
    path: "/grid-template-rows",
    title: "grid-template-rows",
    description: "Utilities for specifying the rows in a grid layout.",
    value: {
        "grid-template-rows": {
            "grid-rows-<number>": "repeat(<number>, minmax(0, 1fr))",
            "grid-rows-none": "none",
            "grid-rows-subgrid": "subgrid",
            "grid-rows-[<value>]": "<value>",
        },
    },
    exampleData: [
        {
            "example": {
                "code": `
<div class="grid grid-flow-col grid-rows-4 gap-4">
  <div>01</div>
  <!-- ... -->
  <div>09</div>
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="grid grid-flow-col grid-rows-4 gap-4">
  <div>01</div>
  <!-- ... -->
  <div>05</div>
  <div class="row-span-3 grid grid-rows-subgrid gap-4">
    <div class="row-start-2">06</div>
  </div>
  <div>07</div>
  <!-- ... -->
  <div>10</div>
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="grid-rows-[200px_minmax(150px,1fr)_50px] ...">
  <!-- ... -->
</div>
                `
            },
        },
    ],
    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">grid-rows-<var>&lt;number&gt;</var></code>
                 utilities like grid-rows-2 and grid-rows-4 to create grids with n equally sized rows:
            </p>

            <div class="relative">
                <div class="absolute inset-0 z-0">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="relative col-start-1 row-start-1 grid grid-flow-col grid-rows-4 gap-4 rounded-lg text-center font-mono text-sm leading-6 font-bold text-color-white">
                    <div class="flex h-14 items-center justify-center rounded-lg bg-color-pink-500 p-4">01</div>
                    <div class="flex h-14 items-center justify-center rounded-lg bg-color-pink-500 p-4">02</div>
                    <div class="flex h-14 items-center justify-center rounded-lg bg-color-pink-500 p-4">03</div>
                    <div class="flex h-14 items-center justify-center rounded-lg bg-color-pink-500 p-4">04</div>
                    <div class="flex h-14 items-center justify-center rounded-lg bg-color-pink-500 p-4">05</div>
                    <div class="flex h-14 items-center justify-center rounded-lg bg-color-pink-500 p-4">06</div>
                    <div class="flex h-14 items-center justify-center rounded-lg bg-color-pink-500 p-4">07</div>
                    <div class="flex h-14 items-center justify-center rounded-lg bg-color-pink-500 p-4">08</div>
                    <div class="flex h-14 items-center justify-center rounded-lg bg-color-pink-500 p-4">09</div>
                </div>
            </div>

            
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">grid-rows-subgrid</code>
                  utility to adopt the row tracks defined by the item's parent:
            </p>

             <div class="relative">
                <div class="grid grid-flow-col grid-rows-4 gap-4 rounded-lg text-center font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="flex h-14 items-center justify-center rounded-lg bg-color-blue-200 p-4">01</div>
                    <div class="flex h-14 items-center justify-center rounded-lg bg-color-blue-200 p-4">02</div>
                    <div class="flex h-14 items-center justify-center rounded-lg bg-color-blue-200 p-4">03</div>
                    <div class="flex h-14 items-center justify-center rounded-lg bg-color-blue-200 p-4">04</div>
                    <div class="flex h-14 items-center justify-center rounded-lg bg-color-blue-200 p-4">05</div>
                    <div class="row-span-3 grid grid-rows-subgrid gap-4">
                        <div class="h-14 rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                         <div class="flex h-14 items-center justify-center rounded-lg bg-color-pink-500 p-4">06</div>
                        <div class="h-14 rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                    </div>
                    <div class="flex h-14 items-center justify-center rounded-lg bg-color-blue-200 p-4">07</div>
                    <div class="flex h-14 items-center justify-center rounded-lg bg-color-blue-200 p-4">08</div>
                    <div class="flex h-14 items-center justify-center rounded-lg bg-color-blue-200 p-4">09</div>
                    <div class="flex h-14 items-center justify-center rounded-lg bg-color-blue-200 p-4">10</div>
                </div>
            </div>
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">grid-rows-[<value>]</code>
                  syntax to set the rows based on a completely custom value:
            </p>

             <div class="relative">
                <div class="absolute inset-0 z-0">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="relative grid grid-flow-col grid-rows-[200px_minmax(150px,_1fr)_50px] gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="flex h-full flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">01</div>
                    <div class="flex h-full flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">02</div>
                    <div class="flex h-full flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">03</div>
                    <div class="flex h-full flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">04</div>
                    <div class="flex h-full flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">05</div>
                    <div class="flex h-full flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">06</div>
                    <div class="flex h-full flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">07</div>
                    <div class="flex h-full flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">08</div>
                    <div class="flex h-full flex-1 items-center justify-center rounded-lg bg-color-pink-500 p-4">09</div>
                </div>
            </div>
            `
        },
    ]
};

export default gridTemplateRow;

<div className="sr-only  grid-rows-[200px_minmax(150px,_1fr)_50px] row-span-3 grid grid-rows-subgrid col-start-1 row-start-1 grid grid-flow-col grid-rows-4 gap-4 rounded-lg text-center font-mono text-sm leading-6 font-bold text-white bg-color-blue-200">



</div>